export const labelForLocationType = (isResidence: boolean): string =>
  isResidence ? 'residence address' : 'destination';

export const tooltipForLocationType = (isResidence: boolean): string =>
  isResidence
    ? 'The primary residence address will be used by default as the morning pickup and afternoon drop-off when scheduling rides for this rider.'
    : 'The primary destination will be used by default as the morning drop-off and afternoon pickup when scheduling rides for this rider.';
